/**
 * Deep log out a value
 */
export const log = (value: any) => console.log(JSON.stringify(value, null, 2));
